const getters = {
	getStoreSpamReport: state => {
        return state.storeSpamReport;
    },
	getCurrentTimestamp: state => {
        return state.currentTimestamp;
    }
}

export default getters